export default {
      id: "brightness_5-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#brightness_5",
      toString: function () {
        return this.url;
      }
    }